module.exports = __webpack_public_path__ + "media/images/icon-challenge@3x-7d3dc08af0011a96b83e1f1276bfc2c5.png";